const ActionTypes = {
  LOADED:       'scripts/loaded',
  NEW:          'scripts/new',
  CREATE_ERROR: 'scripts/create-error',
  CREATED:      'scripts/created',
  EDIT:         'scripts/edit',
  UPDATE_ERROR: 'scripts/update-error',
  UPDATED:      'scripts/updated',
  CANCEL:       'scripts/cancel',
  DELETE:       'scripts/delete',
  DELETE_ERROR: 'scripts/delete-error',
  DELETED:      'scripts/deleted',
  SIMULATE:     'scripts/simulate',
  SIMULATED:    'scripts/simulated',
};

export default ActionTypes;
